export const getWidgetSentryConfig = (environment: string) => ({
  dsn: 'https://80f08270000145e1be987a32c9bc72da@sentry.wixpress.com/139',
  config: {
    environment,
  },
})
